import type React from "react";
import { UserPlus } from "lucide-react";
import { Button } from "@planta-v2/pds-ui/button";
import { i18n } from "@frontend/i18n";

export interface RequestIntroButtonProps {
  readonly onClick: () => void;
  readonly isLoading: boolean;
}

export function RequestIntroButton({
  onClick,
  isLoading,
}: RequestIntroButtonProps): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-2">
      <Button
        onClick={onClick}
        disabled={isLoading}
        data-testid="request-intro-button"
        className="w-full gap-2"
        size="lg"
      >
        <UserPlus className="h-4 w-4" />
        {isLoading
          ? i18n.t("user.directory.profile.cta.requesting")
          : i18n.t("user.directory.profile.cta.requestIntro")}
      </Button>
      <p className="text-pds-2xs text-center text-muted-foreground">
        {i18n.t("user.directory.profile.cta.requestIntroHelp")}
      </p>
    </div>
  );
}
